import {QuestionList} from '../types';
import {drivers} from '../const';
import Cover from '../img/cover.jpg'

export const BeginList: QuestionList = [{
    id: 101,
    img: Cover,
    question: `
<p><b class="gra">Гра «Нам по дорозі»</b></p>

<p>Спробуйте себе у ролі водія! Мета гри – отримати <b>5 зірочок за поїздку</b> від пасажирів <b>хоча б 3 рази</b>. Ви маєте 5 спроб.</p>
    `,
    answers: [
        {
            id: 1,
            text: 'Далі',
            next: 301,
        },
    ],
},{
    id: 301,
    img: Cover,
    question: `
<p><b class="gra">Гра «Нам по дорозі»</b></p>
<p>Історії, в яких ви будете брати участь, засновані на реальних подіях, що трапились з водіями Uklon.</p>
<p>Гра розроблена командою <b>«Хмарочоса»</b> в партнерстві з компанією <b>Uklon</b> до Дня водія.</p>
    `,
    answers: [
        {
            id: 1,
            text: 'Поїхали!',
            next: 102,
        },
    ],
},
    {
        id: 102,
        question: `Оберіть свого персонажа.`,
        answers: [{
            id: 1,
            text: `<p><b>Микита</b>, вимушений переселенець, мешкає у Києві з травня 2022 року</b></p>
<p>Авто: <b>Volkswagen Golf</b></p>
<p>В Uklon: <b>4 місяці</<b></p>
           `,
            characterImg: drivers[0],
            next: 103,
        },
            {
                id: 2,
                text: `<p><b>Ігор</b>, живе та працює в Одесі</p>
<p>Авто: <b>Hyundai Accent</b></p>
<p>В Uklon: <b>3 роки</b></p>`
                ,
                characterImg: drivers[1],
                next: 104,
            },
        ],

    },
    {
        id: 103,
        question: `Микита налаштований отримувати лише «п'ятірки», адже з переїздом до нового міста його родина отримала багато фінансових викликів. Для Микити це – основне місце роботи. Цінує Uklon за гнучкий графік та стабільний заробіток.`,
        answers: [
            {
                id: 1,
                text: 'Вибрати іншого персонажа',
                next: 102,
            },
            {
                id: 2,
                text: 'До роботи!',
                next: 1101,
            },
        ],
    },
    {
        id: 104,
        question: `Ігор налаштований отримувати лише «п'ятірки», аби допомогти товаришу у ЗСУ назбирати на дрон для підрозділу. Для Ігора робота з Uklon – підробіток. Він береться за пару вигідних замовлень на день, коли з пасажиром по дорозі. Цінує можливість додаткового заробітку.`,
        answers: [
            {
                id: 2,
                text: 'Вибрати іншого персонажа',
                next: 102,
            },
            {
                id: 1,
                text: 'До роботи!',
                next: 1101,
            },
        ],
    },

]